<section>
    <div class="not-footer">
        <div class="logo">
        <img src="assets/img/navbar/Join logo vector.png" alt="">
    </div>
    <nav>
        <ul>
            <a class="summary active" (click)="toggleActive('summary'); closeHelp()" routerLink="/summary"><li><img src="assets/img/navbar/Summary.png" alt="">Summary</li></a>
            <a class="task" (click)="toggleActive('task');closeHelp()" routerLink="/task"><li><img src="assets/img/navbar/Add task.png" alt="">Add Task</li></a>
            <a class="board" (click)="toggleActive('board');closeHelp()" routerLink="/board"><li><img src="assets/img/navbar/Board.png" alt="">Board</li></a>
            <a class="contacts" (click)="toggleActive('contacts');closeHelp()" routerLink="/contacts"><li><img src="assets/img/navbar/Contacts.png" alt="">Contacts</li></a>
        </ul>
    </nav>
    </div>
    <footer>
        <a (click)="toggleActive('privacy');" routerLink="/privacy">Privacy Policy</a>
        <a (click)="toggleActive('legalNotice');" routerLink="/legalNotice">Legal notice</a>
    </footer>
</section>